<template>
  <div class="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid" style="background: #F3F6F9;" id="kt_login">
    <!--begin::Aside-->
    <div class="login-aside d-flex flex-column flex-row-auto bg-light-primary">
      <div class="d-flex flex-column-fluid flex-column flex-center justify-content-between">
        <div class="d-none d-lg-flex flex-column-auto flex-column pt-lg-20 pt-15">
          <router-link :to="{ path: '/login' }" class="text-center">
            <img :src="$_config.logo.lg" alt="Logo" class="max-h-90px" />
            <img src="/static/img/logo/adhi/QHSE_720.png" alt="Logo" class="max-h-90px" />
          </router-link>
        </div>
        <div class="text-center mb-10 mt-3 px-3 px-lg-0">
          <h2 class="font-weight-bolder text-dark font-size-h3 font-size-h3-lg mb-3">Formulir Penilaian Pelanggan</h2>
          <h2 v-if="mainData" class="font-weight-bolder text-dark font-size-h3 font-size-h1-lg mb-2">{{ mainData.rel_project_id || '' }}</h2>
          <h2 v-if="mainData" class="font-weight-bolder text-dark font-size-h3 font-size-h1-lg mb-0">{{ mainData.rel_department_id || '' }}</h2>
        </div>
        <div class="text-center">
          <p class="font-weight-bolder font-size-h6 font-size-lg text-dark opacity-70">Quality, Health, Safety &amp; Environment<br>{{ $_config.company }}</p>
        </div>
      </div>
    </div>
    <!--end::Aside-->
    <!--begin::Content-->
    <template v-if="mainData">
      <div :class="!isEnd && mainData.survey_permission? 'flex-column' : 'align-items-center'" class="flex-row-fluid d-flex  position-relative p-7 scrolling-hide" style="height:100vh;overflow:scroll">
        <template v-if="!isEnd">
          <template v-if="mainData.survey_permission">
            <div class="login-content mx-lg-auto">
              <div class="card card-custom mb-3">
                <div class="card-header py-5">
                  <h3 class="card-title align-items-start flex-column">
                    <span class="card-label font-weight-bolder text-dark">Informasi Pribadi</span>
                    <span class="text-dark-75 mt-1 font-weight-bold font-size-sm">Data diri Pelanggan</span>
                  </h3>
                </div>
                <div class="card-body">
                  <s-input v-model="mainData.initiator_name" :item="{ label:'Nama Lengkap', type:'text', validation:[], placeholder: '', api:'' }" />
                  <s-input v-model="mainData.initiator_email" :item="{ label:'Alamat Email', type:'text', validation:[], placeholder: '', api:'' }" />
                  <s-input v-model="mainData.initiator_telephone" :item="{ label:'Nomor Telp.', type:'text', validation:[], placeholder: '', api:'' }" />
                  <s-input v-model="mainData.initiator_institution" :item="{ label:'Instansi / Perusahaan', type:'text', validation:['required'], placeholder: '', api:'' }" />
                  <s-input v-model="mainData.initiator_job_position" :item="{ label:'Jabatan', type:'text', validation:['required'], placeholder: '', api:'' }" />
                  <div class="form-group mb-0">
                    <label>Posisi / Jabatan <span class="text-danger">*</span></label>
                    <div class="radio-list">
                      <label class="radio">
                        <input v-model="mainData.initiator_type" :value="'owner_representatif'" type="radio">
                        <span></span>Owner representatif (Kasatker, PPK, Project Manager Owner, dll)</label>
                      <label class="radio">
                        <input v-model="mainData.initiator_type" :value="'consultant '" type="radio">
                        <span></span>Consultant (Manajemen Konstruksi, Konsultan Pengawas, Konsultan Perencana, dll)</label>
                      <label class="radio">
                        <input v-model="mainData.initiator_type" :value="'partner'" type="radio">
                        <span></span>Rekanan ADHI (Subkon, Vendor, atau Mandor)</label>
                    </div>
                  </div>
                </div>
              </div>
              <template v-for="(a,i) in mainData.child_data_survey_customer_appraisal_items">
                <div :key="i+'-1-child'" class="card card-custom mb-3 bg-light-primary">
                  <div class="card-header border-0 pt-5">
                    <h3 class="card-title align-items-start flex-column">
                      <span class="card-label font-weight-bolder text-dark">PENILAIAN PENERAPAN {{ a.code | parse('modules') }}</span>
                      <span class="text-dark-75 mt-1 font-weight-bold font-size-sm">Survei Penilaian Pelanggan</span>
                    </h3>
                  </div>
                  <div class="card-body pt-2">
                    <ul class="list-unstyled mb-0">
                      <li>Skala 1 = Sangat tidak puas/ sangat tidak baik/ tidak pernah</li>
                      <li>Skala 2 = Tidak Puas/ tidak baik/ jarang</li>
                      <li>Skala 3 = Puas/ baik/ sering</li>
                      <li>Skala 4 = Sangat puas/ sangat baik/ selalu</li>
                      <li>&nbsp;</li>
                      <li>*) <b>Wajib mengisi keterangan apabila skala penilaian 1 dan 2</b></li>
                    </ul>
                  </div>
                </div>
                <template v-for="(b,j) in a.items">
                  <div :key="i+'-'+j+'-2-childs'" class="card card-custom mb-3">
                    <div class="card-header border-0 pt-5">
                      <h4 class="card-title align-items-start flex-column">
                        <span class="card-label font-size-h5 font-weight-bold text-dark">{{ b.item_name }} <span class="text-warning">*</span></span>
                      </h4>
                    </div>
                    <div class="card-body">
                      <div class="radio-inline justify-content-between">
                        <label class="radio radio-lg flex-column m-0 mx-3">
                          <input v-model="b.scale_value" :value="1" type="radio">
                          <span class="mr-0 mb-2"></span>
                          <div class="font-weight-bolder">1</div>
                        </label>
                        <label class="radio radio-lg flex-column m-0 mx-3">
                          <input v-model="b.scale_value" :value="2" type="radio">
                          <span class="mr-0 mb-2"></span>
                          <div class="font-weight-bolder">2</div>
                        </label>
                        <label class="radio radio-lg flex-column m-0 mx-3">
                          <input v-model="b.scale_value" :value="3" type="radio">
                          <span class="mr-0 mb-2"></span>
                          <div class="font-weight-bolder">3</div>
                        </label>
                        <label class="radio radio-lg flex-column m-0 mx-3">
                          <input v-model="b.scale_value" :value="4" type="radio">
                          <span class="mr-0 mb-2"></span>
                          <div class="font-weight-bolder">4</div>
                        </label>
                      </div>
                      <s-input class="mt-3 animated" v-if="b.scale_value && b.scale_value <= 2" v-model="b.description" :item="{ nm: true, label:'Keterangan', type:'textarea', rows:3, validation:['required'], placeholder: 'Deskripsikan penilaian Anda disini...', api:'' }" />
                    </div>
                  </div>
                </template>
                <div :key="i+'-1-recomment'" class="card card-custom mb-3">
                  <div class="card-header border-0 pt-5" style="min-height: 20px;">
                    <h4 class="card-title align-items-start flex-column">
                      <span class="card-label font-size-h5 font-weight-bold text-dark">Rekomendasi PENERAPAN {{ a.code | parse('modules') }}</span>
                    </h4>
                  </div>
                  <div class="card-body pt-0">
                    <s-input v-model="mainData.child_data_survey_customer_appraisal_recomendations[i].recomendation_description" :item="{ nm: true, label:null, type:'textarea', rows:5, validation:[], placeholder: 'Deskripsikan rekomendasi / saran penerapan penilaian disini...', api:'' }" />
                  </div>
                </div>
              </template>
              <button @click="saveSurvey()" class="btn btn-primary btn-lg btn-block text-uppercase">Kirim Penilaian</button>
            </div>
          </template>
          <template v-else>
            <div class="login-content mx-lg-auto">
              <div class="text-center">
                <h1 class="mb-3">Pengisian Formulir Ditutup</h1>
                <h3 v-if="mainData.message_survey_permission">{{ mainData.message_survey_permission }}</h3>
                <h3 v-else>Silahkan hubungi PIC {{ mainData.rel_department_id || '' }} <br>untuk info lebih lanjut</h3>
              </div>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="login-content mx-lg-auto">
            <div class="text-center">
              <h1 class="mb-3">Terimakasih atas penilaian anda</h1>
              <h3>Anda telah berkontribusi dalam pengisian <br>Formulir Penilaian Pelanggan</h3>
            </div>
          </div>
        </template>
      </div>
    </template>
    <!--end::Content-->
  </div>
</template>
<style scoped>
  .login.login-1 .login-aside .aside-img {
    min-height: 450px;
  }
  .login.login-1 .login-signin,
  .login.login-1 .login-signup,
  .login.login-1 .login-forgot {
    display: none;
  }
  .login.login-1.login-signin-on .login-signup {
    display: none;
  }
  .login.login-1.login-signin-on .login-signin {
    display: block;
  }
  .login.login-1.login-signin-on .login-forgot {
    display: none;
  }
  .login.login-1.login-signup-on .login-signup {
    display: block;
  }
  .login.login-1.login-signup-on .login-signin {
    display: none;
  }
  .login.login-1.login-signup-on .login-forgot {
    display: none;
  }
  .login.login-1.login-forgot-on .login-signup {
    display: none;
  }
  .login.login-1.login-forgot-on .login-signin {
    display: none;
  }
  .login.login-1.login-forgot-on .login-forgot {
    display: block;
  }

  @media (min-width: 992px) {
    .login.login-1 .login-aside {
      width: 100%;
      max-width: 700px;
    }
    .login.login-1 .login-content {
      width: 100%;
      max-width: 500px;
    }
    .login.login-1 .login-content .login-form {
      width: 100%;
      max-width: 450px;
    }
  }
  @media (min-width: 992px) and (max-width: 1399.98px) {
    .login.login-1 .login-aside {
      width: 100%;
      max-width: 450px;
    }
  }
  @media (max-width: 991.98px) {
    .login.login-1 .login-content .login-form {
      width: 100%;
      max-width: 400px;
    }
  }
  @media (max-width: 575.98px) {
    .login.login-1 .aside-img {
      min-height: 300px !important;
      background-size: 400px;
    }
    .login.login-1 .login-content .login-form {
      width: 100%;
      max-width: 100%;
    }
  }
</style>
<script>
export default {
  name: 'layanan-pelanggan',
  data () {
    return {
      mainData: null,
      isEnd: false
    }
  },
  mounted () {
    if (this.$route.query.end) this.isEnd = true
    this.getSurvey()
  },
  methods: {
    getSurvey () {
      const filter = {
        department_id: this.$route.query.did,
        project_id: this.$route.query.pid
      }
      this.$_api.get('no-auth/survey-customer-appraisals/scan-qr', filter).then(res => {
        this.mainData = res.data
        this.$set(this.mainData, 'initiator_type', 'owner_representatif')
      }, err => {
        this.$_alert.error(err)
      })
    },
    saveSurvey () {
      this.$_api.post('no-auth/survey-customer-appraisals/create', this.mainData).then(res => {
        // this.getSurvey()
        this.$router.replace({ name: 'survei-pelanggan', query: { pid: this.$route.query.pid, did: this.$route.query.did, end: true } }).catch((err) => {
          return err
        })
        this.isEnd = true
      }, err => {
        this.$_alert.error(err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/data-input/layanan-pelanggan.vue